export default __webpack_public_path__ + "static/media/remove.95e67502.svg";